module.exports = __webpack_public_path__ + "img/image_present.dc5aa42c.png";